<template>
    <div>
        <Button
            @click="show = true"
            color="danger-outline"
            size="small"
            iconName="trash"
            class="w-full"
        >
            Delete
        </Button>

        <ModalConfirmation
            :show="show"
            :action="submit"
            color="danger"
            title="Are you sure you want to delete this meeting location?"
            actionText="Yes, delete"
            :actionProcessing="apiFormRef?.loading.valueOf()"
            @close="show = false"
        >
            <template
                #content
                class="text-gray-500 text-center"
            >
                <div class="text-gray-500 text-center">
                    This action is irreversible.
                </div>
            </template>
        </ModalConfirmation>

        <ApiForm
            :url="
                urlFactory.makeCompanyMeetingLocationDeleteUrl(
                    inPersonHostDefinedMeetingLocation.id,
                )
            "
            method="POST"
            :disableCatch="false"
            ref="apiFormRef"
        />
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import ModalConfirmation from '@/Shared/Component/ModalConfirmation.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import InPersonHostDefinedMeetingLocation from '@/App/Company/Entity/InPersonHostDefinedMeetingLocation'

    const emit = defineEmits<{
        onSuccess: [
            {
                inPersonHostDefinedMeetingLocations: InPersonHostDefinedMeetingLocation[]
            },
        ]
    }>()

    const props = defineProps({
        inPersonHostDefinedMeetingLocation: {
            type: Object as PropType<InPersonHostDefinedMeetingLocation>,
            required: true,
        },
    })

    const show = ref<boolean>(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                const updatedInPersonHostDefinedMeetingLocations =
                    response.getHydratedInPersonHostDefinedMeetingLocations(
                        ResponseJsonKeyEnum.App_Company_InPersonHostDefinedMeetingLocations,
                    )

                emit('onSuccess', {
                    inPersonHostDefinedMeetingLocations:
                        updatedInPersonHostDefinedMeetingLocations,
                })

                show.value = false
            })
            ?.catch(() => {
                show.value = false
            })
    }
    const urlFactory = new UrlFactory()
</script>
